import * as yup from 'yup'

const schema = yup.object({
  title: yup.string().required(),
  origin: yup.string().required(),
  status: yup.string().required(),
  justification: yup.string().required(),
  expectedBenefit: yup.string().required(),
  plannedActions: yup.string().required(),
  responsibleId: yup.mixed().nullable().required(),
  endDatePlanned: yup.date().required(),
  improvementType: yup.string().nullable(),
  participants: yup.array().of(yup.mixed()).nullable(),
  departmentId: yup.string().required(),
  resourcesNeeded: yup.string().nullable(),
  estimatedInvestment: yup.string().nullable(),
  startDatePlanned: yup
    .date()
    .nullable()
    .test(
      'before-end-date',
      'Data início prevista não pode ser após a data fim prevista',
      function (value) {
        const { endDatePlanned } = this.parent
        if (!value || !endDatePlanned) return true
        return new Date(value) <= new Date(endDatePlanned)
      },
    ),
  successCriteria: yup.string().nullable(),
  impactedKpiId: yup.string().nullable(),
  resultObtained: yup.string().nullable(),
})

export default schema
